import { SortDirection } from "@safetyculture/s12-apis-connect-web/s12/common/sorting_pb";
import {
  UserSortType,
  UserStatus,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_user_pb";

import { getOrgUserList } from "api/endpoints/organisation";
import { callOptionsHeaders } from "api/helpers";

// Cap requests so a job list with many distinct creators doesn't blow past
// the backend's page-size limits in a single call.
export const USER_LOOKUP_CHUNK_SIZE = 100;

export const fetchUserNameMap = async (
  userS12Ids: string[],
  organizationId: string,
  regionCode: string,
  roleId: string,
): Promise<Map<string, string>> => {
  const map = new Map<string, string>();
  const unique = Array.from(new Set(userS12Ids.filter(Boolean)));
  if (unique.length === 0) {
    return map;
  }

  const headers = callOptionsHeaders(regionCode, roleId);
  for (let i = 0; i < unique.length; i += USER_LOOKUP_CHUNK_SIZE) {
    const chunk = unique.slice(i, i + USER_LOOKUP_CHUNK_SIZE);
    const resp = await getOrgUserList(
      {
        organizationId,
        pageSize: chunk.length,
        offset: 0,
        sortDirection: SortDirection.ASC,
        sortType: UserSortType.FIRST_NAME,
        userIds: chunk,
        userStatus: UserStatus.UNSPECIFIED,
        allowUsersOutsideOrg: true,
      },
      headers,
    );
    for (const u of resp.users) {
      const name = `${u.firstName ?? ""} ${u.lastName ?? ""}`.trim();
      if (name) {
        map.set(u.id, name);
      }
    }
  }
  return map;
};
